export const LANGUAGES = ['es', 'en', 'fr', 'de'] as const
export const LANG = process.env.NEXT_PUBLIC_LOCALE as typeof LANGUAGES[number]
export const HOSTNAME = process.env.NEXT_PUBLIC_PROJECT_HOSTNAME
export const CLIENT_NAME = process.env.NEXT_PUBLIC_CLIENT_NAME
// export const DY_CMS = process.env.DY_CMS
export const DEV = process.env.NEXT_PUBLIC_VERCEL_ENV === 'development'
export const STAGING = process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview'
export const PRO = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'
export const DY_BEARER = process.env.DY_BEARER === 'true'

export * from './base'
export * from './project'
